// extracted by mini-css-extract-plugin
module.exports =  {"results":"SearchResults-Kx7C__results","noresults":"SearchResults-b1G8__noresults"};